import Box from "ds/components/Box";
import TableHeadColumn from "ds/components/Table/Head/Column";
import { getHeadColumnKey } from "ds/components/Table/Head/helpers";
import TableHeadInteractiveColumnTitle from "ds/components/Table/Head/InteractiveColumn/Title";
import useColumnSort from "ds/components/Table/hooks/useColumnSort";
import { TableColumnMeta } from "ds/components/Table/types";

type EnvironmentTableColumnProps = {
  column: TableColumnMeta;
  tableId: string;
};

const EnvironmentTableColumn = ({ column, tableId }: EnvironmentTableColumnProps) => {
  const { ariaSort, handleSort, icon } = useColumnSort(column.id, tableId);

  return (
    <TableHeadColumn key={getHeadColumnKey(column)} column={column} ariaSort={ariaSort}>
      <Box fullHeight align="center">
        {column.noHeader && <span className="sr-only">{column.title}</span>}
        <TableHeadInteractiveColumnTitle
          title={column.noHeader ? "" : column.title}
          onSort={handleSort}
          sortIcon={icon}
          allowsSorting={column.allowsSorting}
        />
      </Box>
    </TableHeadColumn>
  );
};

export default EnvironmentTableColumn;
